export const WORLD_MAPPINGS = {
    0x0: "world",
    0x1: "west hyrule towns",
    0x2: "east hyrule towns",
    0x3: "palace set 1",
    0x4: "palace set 2",
    0x5: "grand palace"
}

export const WORLD_INDEX_MAPPINGS = {
    0x0: "west hyrule",
    0x1: "dm/maze island",
    0x2: "east hyrule"
}

const OVERWORLD_SMALL_OBJECTS = {
    0x0: {name: "headstone",                    height: 1, width: 1, type: "wide"},
    0x1: {name: "cross",                        height: 1, width: 1, type: "wide"},
    0x2: {name: "angled cross",                 height: 1, width: 1, type: "wide"},
    0x3: {name: "tree stump",                   height: 2, width: 1, type: "tall", solid: true},
    0x4: {name: "stone table",                  height: 4, width: 4, type: "tall", solid: true},
    0x5: {name: "zelda",                        height: 1, width: 2, type: "wide"},
    0x6: {name: "zelda",                        height: 1, width: 2, type: "wide"},
    0x7: {name: "pit",                          height: 1, width: 1, type: "wide"},
    0x8: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0x9: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xA: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xB: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xC: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xD: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xE: {name: "cloud",                        height: 1, width: 1, type: "wide"},
    0xF: {name: "cloud",                        height: 1, width: 1, type: "wide"},
}

const OVERWORLD_LARGE_OBJECTS = [
{
    0x1: { name: "",                            height: 2, width: 1, type: "wide", solid: true},
    0x2: { name: "forest ceiling",              height: 2, width: 1, type: "wide"},
    0x3: { name: "forest ceiling",              height: 2, width: 1, type: "wide"},
    0x4: { name: "curtains",                    height: 2, width: 1, type: "wide"},
    0x5: { name: "forest ceiling",              height: 1, width: 1, type: "wide"},
    0x6: { name: "handy glove block",           height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x7: { name: "horizontal pit",              height: 1, width: 1, type: "wide"},
    0x8: { name: "single weed",                 height: 1, width: 1, type: "wide"},
    0x9: { name: "two weeds",                   height: 1, width: 1, type: "wide"},
    0xA: { name: "north castle steps",          height: 1, width: 1, type: "wide"},
    0xB: { name: "background bricks",           height: 1, width: 1, type: "wide"},
    0xC: { name: "volcano background",          height: 1, width: 1, type: "wide"},
    0xD: { name: "handy glove block",           height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xE: { name: "background tree",             height: 1, width: 1, type: "tall"},
    0xF: { name: "column",                      height: 1, width: 1, type: "tall"},
}, {
    0x1: { name: "",                            height: 2, width: 1, type: "wide"},
    0x2: { name: "rock floor",                  height: 2, width: 1, type: "wide", solid: true},
    0x3: { name: "rock ceiling",                height: 2, width: 1, type: "wide", solid: true},
    0x4: { name: "bridge",                      height: 2, width: 1, type: "wide", solid: true},
    0x5: { name: "cave blocks",                 height: 1, width: 1, type: "wide", solid: true},
    0x6: { name: "handy glove blocks",          height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x7: { name: "collapsing bridge",           height: 1, width: 1, type: "wide", solid: true, collapsing: true},
    0x8: { name: "single weed",                 height: 1, width: 1, type: "wide"},
    0x9: { name: "two weeds",                   height: 1, width: 1, type: "wide"},
    0xA: { name: "horizontal pit",              height: 1, width: 1, type: "wide"},
    0xB: { name: "background bricks",           height: 1, width: 1, type: "wide"},
    0xC: { name: "volcano background",          height: 1, width: 1, type: "wide"},
    0xD: { name: "handy glove block",           height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xE: { name: "rock floor",                  height: 2, width: 1, type: "wide", solid: true},
    0xF: { name: "stone spire",                 height: 2, width: 1, type: "tall", solid: true},
}
]

const TOWN_SMALL_OBJECTS = {
    0x0: { name: "open door grass",             height: 3, width: 1, type: "wide", clear: true},
    0x1: { name: "closed door grass",           height: 3, width: 1, type: "wide", clear: true},
    0x2: { name: "open door h bricks",          height: 3, width: 1, type: "wide", clear: true},
    0x3: { name: "open door v bricks",          height: 3, width: 1, type: "wide", clear: true},
    0x4: { name: "stone table",                 height: 1, width: 1, type: "wide"},
    0x5: { name: "chair",                       height: 1, width: 1, type: "wide"},
    0x6: { name: "?",                           height: 1, width: 1, type: "wide"},
    0x7: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0x8: { name: "table",                       height: 1, width: 1, type: "wide"},
    0x9: { name: "bench",                       height: 1, width: 1, type: "wide"},
    0xA: { name: "cross",                       height: 1, width: 1, type: "wide"},
    0xB: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0xC: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0xD: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0xE: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0xF: { name: "cloud",                       height: 1, width: 1, type: "wide"},
}

const TOWN_LARGE_OBJECTS = [
{
    0x1: { name: "",                            height: 2, width: 1, type: "wide", solid: true},
    0x2: { name: "cross thatched roof",         height: 2, width: 1, type: "wide", solid: true},
    0x3: { name: "gray vertical roof",          height: 2, width: 1, type: "wide", solid: true},
    0x4: { name: "green vertical roof",         height: 2, width: 1, type: "wide", solid: true},
    0x5: { name: "brick building",              height: 1, width: 1, type: "wide", toGround: true},
    0x6: { name: "white building",              height: 1, width: 1, type: "wide", toGround: true},
    0x7: { name: "grass building",              height: 1, width: 1, type: "wide", toGround: true},
    0x8: { name: "white brick wall",            height: 1, width: 1, type: "wide"},
    0x9: { name: "log building",                height: 1, width: 1, type: "wide", toGround: true},
    0xA: { name: "brown windows square",        height: 2, width: 1, type: "wide"},
    0xB: { name: "gray windows round",          height: 2, width: 1, type: "wide"},
    0xC: { name: "brown windows round",         height: 2, width: 1, type: "wide"},
    0xD: { name: "blue bricks",                 height: 2, width: 1, type: "wide", solid: true},
    0xE: { name: "column",                      height: 2, width: 1, type: "tall"},
    0xF: { name: "castle background bricks",    height: 1, width: 1, type: "tall"},
},{
    0x1: { name: "",                            height: 2, width: 1, type: "wide", solid: true},
    0x2: { name: "cross thatched roof",         height: 2, width: 1, type: "wide", solid: true},
    0x3: { name: "gray vertical roof",          height: 2, width: 1, type: "wide", solid: true},
    0x4: { name: "green vertical roof",         height: 2, width: 1, type: "wide", solid: true},
    0x5: { name: "brick building",              height: 1, width: 1, type: "wide", toGround: true},
    0x6: { name: "white building",              height: 1, width: 1, type: "wide", toGround: true},
    0x7: { name: "grass building",              height: 1, width: 1, type: "wide", toGround: true},
    0x8: { name: "white brick wall",            height: 1, width: 1, type: "wide", solid: true},
    0x9: { name: "log building",                height: 1, width: 1, type: "wide"},
    0xA: { name: "brown windows square",        height: 2, width: 1, type: "wide"},
    0xB: { name: "gray windows round",          height: 2, width: 1, type: "wide"},
    0xC: { name: "brown windows round",         height: 2, width: 1, type: "wide"},
    0xD: { name: "blue bricks",                 height: 2, width: 1, type: "tall", solid: true},
    0xE: { name: "column",                      height: 2, width: 1, type: "tall"},
    0xF: { name: "castle background bricks",    height: 1, width: 1, type: "tall"},
}
]

const PALACE_SMALL_OBJECTS = {
    0x0: { name: "window",                      height: 4, width: 1, type: "tall"},
    0x1: { name: "rightward unicorn",           height: 1, width: 1, type: "tall"},
    0x2: { name: "leftward wolf",               height: 1, width: 1, type: "tall"},
    0x3: { name: "crystal statue",              height: 5, width: 4, type: "tall"},
    0x4: { name: "crystal statue",              height: 5, width: 4, type: "wide"},
    0x5: { name: "locked door",                 height: 3, width: 1, type: "wide", locked: true},
    0x6: { name: "locked door",                 height: 3, width: 1, type: "wide", locked: true},
    0x7: { name: "cloud",                       height: 1, width: 1, type: "wide"},
    0x8: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0x9: { name: "ironknuckle statue",          height: 2, width: 1, type: "wide"},
    0xA: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0xB: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0xC: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0xD: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0xE: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
    0xF: { name: "small cloud",                 height: 1, width: 1, type: "wide"},
}

const PALACE_LARGE_OBJECTS = [
{
    0x1: { name: "horizontal pit",              height: 1, width: 1, type: "wide", clear: true},
    0x2: { name: "horizontal bricks",           height: 1, width: 1, type: "wide", solid: true},
    0x3: { name: "breakable blocks",            height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x4: { name: "steel blocks",                height: 1, width: 1, type: "wide", solid: true},
    0x5: { name: "breaking bridge",             height: 1, width: 1, type: "wide", solid: true, collapsing: true},
    0x6: { name: "breakable blocks",            height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x7: { name: "horizontal bricks",           height: 2, width: 1, type: "wide", solid: true},
    0x8: { name: "curtains",                    height: 2, width: 1, type: "wide"},
    0x9: { name: "breakable blocks",            height: 2, width: 1, type: "wide", solid: true, breakable: true},
    0xA: { name: "horizontal bricks",           height: 2, width: 1, type: "wide", solid: true},
    0xB: { name: "breakable blocks",            height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xC: { name: "walk-thru bricks",            height: 1, width: 1, type: "tall", clear: true},
    0xD: { name: "breakable blocks",            height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xE: { name: "pit",                         height: 2, width: 1, type: "tall", clear: true},
    0xF: { name: "horizontal pit",              height: 1, width: 1, type: "wide", clear: true, toGround: true},
},
{
    0x1: { name: "horizontal pit",              height: 1, width: 1, type: "wide", clear: true},
    0x2: { name: "horizontal bricks",           height: 1, width: 1, type: "wide", solid: true},
    0x3: { name: "breakable blocks",            height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x4: { name: "steel blocks",                height: 1, width: 1, type: "wide", solid: true},
    0x5: { name: "breaking bridge",             height: 1, width: 1, type: "wide", solid: true, collapsing: true},
    0x6: { name: "breakable blocks",            height: 1, width: 1, type: "wide", solid: true, breakable: true},
    0x7: { name: "horizontal bricks",           height: 2, width: 1, type: "wide", solid: true},
    0x8: { name: "curtains",                    height: 2, width: 1, type: "wide"},
    0x9: { name: "breakable blocks",            height: 2, width: 1, type: "wide", solid: true, breakable: true},
    0xA: { name: "horizontal bricks",           height: 2, width: 1, type: "wide", solid: true},
    0xB: { name: "breakable blocks",            height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xC: { name: "walk-thru bricks",            height: 1, width: 1, type: "tall", clear: true},
    0xD: { name: "breakable blocks",            height: 1, width: 1, type: "tall", solid: true, breakable: true},
    0xE: { name: "pit",                         height: 2, width: 1, type: "tall", clear: true},
    0xF: { name: "horizontal pit",              height: 1, width: 1, type: "wide", clear: true, toGround: true},
}
]

export const ENEMY_MAPPINGS = [
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Red Jar", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot (blue)", height: 1 },
        0x05: { name: "Bit (red)", height: 1 },
        0x06: { name: "Moa", height: 1 },
        0x07: { name: "Ache", height: 0 },
        0x08: { name: "???", height: 1 },
        0x09: { name: "???", height: 1 },
        0x0A: { name: "Acheman", height: 0 },
        0x0B: { name: "Bubble generator", height: 0 },
        0x0C: { name: "Rock Generator", height: 0 },
        0x0D: { name: "Red Deeler", height: 0 },
        0x0E: { name: "Blue Deeler", height: 0 },
        0x0F: { name: "Bago Bago Generator", height: 0 },
        0x10: { name: "Bago Bago", height: 1 },
        0x11: { name: "Red Octoroc (Jumping Only)", height: 1 },
        0x12: { name: "Red Octorock (Moving and Jumping)", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Orange Moblin", height: 2 },
        0x15: { name: "Red Moblin", height: 2 },
        0x16: { name: "Blue Moblin", height: 2 },
        0x17: { name: "Orange Diara", height: 2 },
        0x18: { name: "Red Diara", height: 2 },
        0x19: { name: "Orange Goryia", height: 2 },
        0x1A: { name: "Red Goryia", height: 2 },
        0x1B: { name: "Blue Goryia", height: 2 },
        0x1C: { name: "Lowder", height: 1 },
        0x1D: { name: "Moby generator", height: 1 },
        0x1E: { name: "Moby", height: 1 },
        0x1F: { name: "Megmet", height: 1 },
        0x20: { name: "Geldarm", height: 3 },
        0x21: { name: "Dumb Moblin Generator", height: 0 },
        0x22: { name: "Dumb Moblin", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Red Jar", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot (blue)", height: 1 },
        0x05: { name: "Bit (red)", height: 1 },
        0x06: { name: "Moa", height: 1 },
        0x07: { name: "Ache", height: 0 },
        0x08: { name: "???", height: 1 },
        0x09: { name: "???", height: 1 },
        0x0A: { name: "Acheman", height: 0 },
        0x0B: { name: "Bubble generator", height: 0 },
        0x0C: { name: "Rock Generator", height: 0 },
        0x0D: { name: "Red Deeler", height: 0 },
        0x0E: { name: "Blue Deeler", height: 0 },
        0x0F: { name: "Bago Bago Generator", height: 0 },
        0x10: { name: "Bago Bago", height: 1 },
        0x11: { name: "Red Octoroc (Jumping Only)", height: 1 },
        0x12: { name: "Red Octorock (Moving and Jumping)", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Orange Moblin", height: 2 },
        0x15: { name: "Red Moblin", height: 2 },
        0x16: { name: "Blue Moblin", height: 2 },
        0x17: { name: "Orange Diara", height: 2 },
        0x18: { name: "Red Diara", height: 2 },
        0x19: { name: "Orange Goryia", height: 2 },
        0x1A: { name: "Red Goryia", height: 2 },
        0x1B: { name: "Blue Goryia", height: 2 },
        0x1C: { name: "Lowder", height: 1 },
        0x1D: { name: "Moby generator", height: 0 },
        0x1E: { name: "Moby", height: 1 },
        0x1F: { name: "Megmet", height: 1 },
        0x20: { name: "Geldarm", height: 4 },
        0x21: { name: "Dumb Moblin Generator", height: 1 },
        0x22: { name: "Dumb Moblin", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Red Magic Jar", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot (blue)", height: 1 },
        0x05: { name: "Bit (red)", height: 1 },
        0x06: { name: "Moa", height: 1 },
        0x07: { name: "Ache", height: 0 },
        0x08: { name: "???", height: 1 },
        0x09: { name: "???", height: 1 },
        0x0A: { name: "Acheman", height: 0 },
        0x0B: { name: "Bubble Generator", height: 0 },
        0x0C: { name: "Rock Generator (messed up link-doll sprite in east hyrule)", height: 0 },
        0x0D: { name: "Red Deeler", height: 0 },
        0x0E: { name: "Blue Deeler", height: 0 },
        0x0F: { name: "Bago Bago Generator", height: 0 },
        0x10: { name: "Bago Bago", height: 1 },
        0x11: { name: "Blue Octoroc (Jumping Only)", height: 1 },
        0x12: { name: "Blue Octorock (Moving and Jumping)", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Tektite", height: 2 },
        0x15: { name: "Eye", height: 1 },
        0x16: { name: "Leever", height: 1 },
        0x17: { name: "Boon", height: 1 },
        0x18: { name: "Basilisk", height: 1 },
        0x19: { name: "Scorpion", height: 1 },
        0x1A: { name: "Red Lizalfo", height: 2 },
        0x1B: { name: "Orange Lizalfo", height: 2 },
        0x1C: { name: "Blue Lizalfo", height: 2 },
        0x1D: { name: "Boulder Tossing Lizalfos", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Red Magic Jar", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot (blue)", height: 1 },
        0x05: { name: "Bit (red)", height: 1 },
        0x06: { name: "Moa", height: 1 },
        0x07: { name: "Ache", height: 0 },
        0x08: { name: "???", height: 1 },
        0x09: { name: "???", height: 1 },
        0x0A: { name: "Acheman", height: 0 },
        0x0B: { name: "Bubble Generator", height: 0 },
        0x0C: { name: "Rock Generator (messed up link-doll sprite in east hyrule)", height: 0 },
        0x0D: { name: "Red Deeler", height: 0 },
        0x0E: { name: "Blue Deeler", height: 0 },
        0x0F: { name: "Bago Bago Generator", height: 0 },
        0x10: { name: "Bago Bago", height: 1 },
        0x11: { name: "Blue Octoroc (Jumping Only)", height: 1 },
        0x12: { name: "Blue Octorock (Moving and Jumping)", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Tektite", height: 2 },
        0x15: { name: "Eye", height: 1 },
        0x16: { name: "Leever", height: 1 },
        0x17: { name: "Boon", height: 1 },
        0x18: { name: "Basilisk", height: 1 },
        0x19: { name: "Scorpion", height: 1 },
        0x1A: { name: "Red Lizalfo", height: 2 },
        0x1B: { name: "Orange Lizalfo", height: 2 },
        0x1C: { name: "Blue Lizalfo", height: 2 },
        0x1D: { name: "Boulder Tossing Lizalfos", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Candle", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Purple Kees", height: 1 },
        0x04: { name: "Purple Bot", height: 1 },
        0x05: { name: "Bit", height: 1 },
        0x06: { name: "Purple Moa", height: 1 },
        0x07: { name: "Purple Kees (again?)", height: 1 }
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Item in Palace Sprite", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot", height: 1 },
        0x05: { name: "Strike for Red Jar", height: 2 },
        0x06: { name: "Slow Magic Stealing Skull", height: 1 },
        0x07: { name: "Orange Moa", height: 1 },
        0x08: { name: "Falling Block Generator", height: 0 },
        0x09: { name: "Single falling block", height: 0 },
        0x0A: { name: "Blue Skull Head", height: 1 },
        0x0B: { name: "Rathead Generator", height: 0 },
        0x0C: { name: "Rathead", height: 2 },
        0x0D: { name: "Dripping Column", height: 0 },
        0x0E: { name: "Fast Magic Stealing Skull", height: 1 },
        0x0F: { name: "Bago Bago Generator", height: 0 },
        0x10: { name: "Bago Bago", height: 1 },
        0x11: { name: "Rope Jumping Only", height: 1 },
        0x12: { name: "Rope Jumping and Moving", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Crystal Slot", height: 1 },
        0x15: { name: "Crystal", height: 1 },
        0x16: { name: "Energy ball shooter (to down-right)", height: 1 },
        0x17: { name: "Energy ball shooter (to down-left)", height: 1 },
        0x18: { name: "Orange Iron Knuckle", height: 2 },
        0x19: { name: "Red Iron Knuckle", height: 2 },
        0x1A: { name: "Blue Iron Knuckle", height: 2 },
        0x1B: { name: "Wolf Head Generator", height: 0 },
        0x1C: { name: "Wolf Head", height: 1 },
        0x1D: { name: "Mago", height: 1 },
        0x1E: { name: "Hammer Thrower", height: 2 },
        0x1F: { name: "Red Stalfos", height: 2 },
        0x20: { name: "Horse Head", height: 3 },
        0x21: { name: "Helmethead/Gooma (5th Palace Boss)", height: 3 },
        0x22: { name: "Helmethead's floating head", height: 1 },
        0x23: { name: "Blue Stalfos", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Item in Palace sprite", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot", height: 1 },
        0x05: { name: "Strike for Red Jar/Ironknuckle", height: 2 },
        0x06: { name: "Slow Magic Stealing Skulls", height: 1 },
        0x07: { name: "Orange Moa", height: 1 },
        0x08: { name: "Falling Blocks Generator", height: 0 },
        0x09: { name: "Single falling block", height: 0 },
        0x0A: { name: "Blue Skull Head", height: 1 },
        0x0B: { name: "Rathead Generator", height: 0 },
        0x0C: { name: "Rathead", height: 2 },
        0x0D: { name: "Dripping Column", height: 0 },
        0x0E: { name: "Fast Magic Stealing Skulls", height: 1 },
        0x0F: { name: "???", height: 1 },
        0x10: { name: "Flame", height: 1 },
        0x11: { name: "Rope", height: 1 },
        0x12: { name: "???", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Crystal Slot", height: 1 },
        0x15: { name: "Crystal", height: 1 },
        0x16: { name: "Energy ball shooter (to down-right)", height: 1 },
        0x17: { name: "Energy ball shooter (to down-left)", height: 1 },
        0x18: { name: "Orange Iron Knuckle", height: 2 },
        0x19: { name: "Red Iron Knuckle", height: 2 },
        0x1A: { name: "Blue Iron Knuckle", height: 2 },
        0x1B: { name: "Wolf Head Generator", height: 0 },
        0x1C: { name: "Wolf Head", height: 1 },
        0x1D: { name: "Wizrobe", height: 2 },
        0x1E: { name: "Red Stalfos Knight", height: 2 },
        0x1F: { name: "Doomknocker", height: 2 },
        0x20: { name: "Blue Iron Knuckle on horse", height: 2 },
        0x21: { name: "Dragon (6th palace boss)", height: 4 },
        0x22: { name: "Wizard (4th palace boss)", height: 3 },
        0x23: { name: "Blue Stalfos Knight", height: 2 },
    },
    {
        0x00: { name: "Fairy", height: 1 },
        0x01: { name: "Red Magic Jar", height: 1 },
        0x02: { name: "Locked Door", height: 2 },
        0x03: { name: "Myu", height: 1 },
        0x04: { name: "Bot (blue)", height: 1 },
        0x05: { name: "Bit (red)", height: 1 },
        0x06: { name: "Moa", height: 1 },
        0x07: { name: "Ache", height: 0 },
        0x08: { name: "???", height: 1 },
        0x09: { name: "???", height: 1 },
        0x0A: { name: "Acheman", height: 0 },
        0x0B: { name: "Bubble Generator", height: 0 },
        0x0C: { name: "Rock Generator", height: 0 },
        0x0D: { name: "Red Deeler", height: 1 },
        0x0E: { name: "Blue Deeler", height: 1 },
        0x0F: { name: "Fire Bago Bago Generator", height: 0 },
        0x10: { name: "Fire Bago Bago", height: 1 },
        0x11: { name: "Fire Rope Jumping Only", height: 1 },
        0x12: { name: "Fire Rope Jumping and Moving", height: 1 },
        0x13: { name: "Elevator", height: 2 },
        0x14: { name: "Slow Magic Stealing Skull", height: 1 },
        0x15: { name: "Fast Magic Stealing Skull", height: 1 },
        0x16: { name: "Orange Skull Head", height: 1 },
        0x17: { name: "Large Magic Stealing Skull", height: 1 },
        0x18: { name: "Orange Dreadhawk", height: 2 },
        0x19: { name: "Red Dreadhawk", height: 2 },
        0x1A: { name: "Blue Dreadhawk", height: 2 },
        0x1B: { name: "???", height: 1 },
        0x1C: { name: "???", height: 1 },
        0x1D: { name: "Firebird", height: 2 },
        0x1E: { name: "King Bot", height: 2 },
        0x1F: { name: "???", height: 1 },
        0x20: { name: "Barrier for Grand Palace", height: 4 },
        0x21: { name: "???", height: 1 },
        0x22: { name: "Thunder Bird Boss", height: 3 },
        0x23: { name: "Trigger for Dark Link battle", height: 0 },
    }
]

export const ENEMY_RANDO_EXCLUSIONS = [
    // West Hyrule, Death Mountain (mapSet 0) - crashes: 0x08-0x09, 0x23-0xFF
    [0x0, 0x1, 0x2, 0x8, 0x9, 0xb, 0xc, 0x13, ...Array.from({length: 0xFF - 0x23 + 1}, (_, i) => 0x23 + i)],
    // East Hyrule, Maze Island (mapSet 1) - crashes: 0x08-0x09, 0x1E-0xFF  
    [0x0, 0x1, 0x2, 0x8, 0x9, 0xb, 0xc, 0x13, ...Array.from({length: 0xFF - 0x1E + 1}, (_, i) => 0x1E + i)],
    // Additional overworld areas (mapSet 2, 3) - same as West Hyrule pattern
    [0x0, 0x1, 0x2, 0x8, 0x9, 0xb, 0xc, 0x13, ...Array.from({length: 0xFF - 0x23 + 1}, (_, i) => 0x23 + i)],
    [0x0, 0x1, 0x2, 0x8, 0x9, 0xb, 0xc, 0x13, ...Array.from({length: 0xFF - 0x1E + 1}, (_, i) => 0x1E + i)],
    // Towns (mapSet 4) - crashes: 0x08, 0x25-0xFF
    [0x0, 0x1, 0x2, 0x8, ...Array.from({length: 0xFF - 0x25 + 1}, (_, i) => 0x25 + i)],
    // Palace 1,2,5 (mapSet 5) - crashes: 0x24-0xFF
    [0x00, 0x01, 0x02, 0x05, 0x08, 0x09, 0xd, 0xf, 0x12, 0x13, 0x14, 0x15, 0x16, 0x17, 0x20, 0x21, 0x22, ...Array.from({length: 0xFF - 0x24 + 1}, (_, i) => 0x24 + i)],
    // Palace 3,4,6 (mapSet 6) - crashes: 0x24-0xFF
    [0x00, 0x01, 0x02, 0x05, 0x08, 0x09, 0xd, 0xf, 0x12, 0x13, 0x14, 0x15, 0x16, 0x17, 0x20, 0x21, 0x22, ...Array.from({length: 0xFF - 0x24 + 1}, (_, i) => 0x24 + i)],
    // Great Palace (mapSet 7) - crashes: 0x24-0xFF
    [0x00, 0x01, 0x02, 0x08, 0x09, 0xb, 0xc, 0x13, 0x1b, 0x1c, 0x1f, 0x20, 0x21, 0x22, 0x23, ...Array.from({length: 0xFF - 0x24 + 1}, (_, i) => 0x24 + i)]
]

export const SMALL_OBJECTS = [
    OVERWORLD_SMALL_OBJECTS,
    OVERWORLD_SMALL_OBJECTS,
    OVERWORLD_SMALL_OBJECTS,
    OVERWORLD_SMALL_OBJECTS,
    TOWN_SMALL_OBJECTS,
    PALACE_SMALL_OBJECTS,
    PALACE_SMALL_OBJECTS,
    PALACE_SMALL_OBJECTS
]

export const LARGE_OBJECT_SETS = [
    OVERWORLD_LARGE_OBJECTS,
    OVERWORLD_LARGE_OBJECTS,
    OVERWORLD_LARGE_OBJECTS,
    OVERWORLD_LARGE_OBJECTS,
    TOWN_LARGE_OBJECTS,
    PALACE_LARGE_OBJECTS,
    PALACE_LARGE_OBJECTS,
    PALACE_LARGE_OBJECTS
]

// Item Priority Classification for Two-Phase Placement
export const CRITICAL_PATH_ITEMS = [
    "BOOTS",      // Only water traversal method
    "RAFT",       // Only East ↔ West Hyrule travel
    "HANDY_GLOVE", // Block manipulation (palace progression)
    "JUMP",       // Required for palace progression
    "LIFE",       // Required for palace progression
    "FAIRY",      // Required for palace progression
    "REFLECT",    // Required for palace progression
    "THUNDER"     // Required for palace progression
];

export const QUALITY_OF_LIFE_ITEMS = [
    "MAGIC_KEY",  // Only needed for P6 access
    "CANDLE",     // Makes dark areas easier
    "FIRE",       // Borderline useless
    "SHIELD",     // Not critical for progression
    "SPELL"       // Only opens one optional item location in New Kasuto
];